import { NgModule } from '@angular/core';
import { ModalDialogComponent } from '../common/modal/modalDialog.component';
import { CommonModule } from '@angular/common';
import { PowerbiModalComponent } from './launcher/powerbi/components/powerbi-modal/powerbi-modal.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    ModalDialogComponent,
    PowerbiModalComponent
  ],
  exports: [
    ModalDialogComponent,
    PowerbiModalComponent
  ]
})
export class DialogModule { }
